var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcProfile = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  viewBox: "0 0 34 34",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3f68b5;}.b,.c,.d{fill:none;}.d{stroke:#fff;stroke-width:1.5px;}.e,.f{stroke:none;}.f{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1652 -93)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "a",
  cx: 17,
  cy: 17,
  r: 17,
  transform: "translate(1652 93)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1161.855 -20.145)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "b",
  width: 24,
  height: 24,
  transform: "translate(495.145 118.145)"
}), /*#__PURE__*/React.createElement("g", {
  className: "c",
  transform: "translate(-2206.583 -1698.337)"
}, /*#__PURE__*/React.createElement("path", {
  className: "e",
  d: "M2703.726,1838.483h20s-.006-1.8,0-2.5-2.815-5.354-10.21-5.354-9.8,4.789-9.794,5.569S2703.726,1838.483,2703.726,1838.483Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "f",
  d: "M 2722.227294921875 1836.9833984375 C 2722.227294921875 1836.686645507812 2722.227783203125 1836.395751953125 2722.228759765625 1836.1640625 C 2722.071533203125 1835.839233398438 2721.461181640625 1834.896728515625 2720.16357421875 1833.993041992188 C 2718.941650390625 1833.141845703125 2716.796875 1832.127197265625 2713.520263671875 1832.127197265625 C 2710.92431640625 1832.127197265625 2708.693603515625 1832.795654296875 2707.0693359375 1834.060180664062 C 2705.843017578125 1835.014892578125 2705.330322265625 1836.016723632812 2705.2265625 1836.314453125 C 2705.226806640625 1836.51318359375 2705.226806640625 1836.745727539062 2705.22705078125 1836.9833984375 L 2722.227294921875 1836.9833984375 M 2723.72998046875 1838.4833984375 L 2703.726318359375 1838.4833984375 C 2703.726318359375 1838.4833984375 2703.727783203125 1836.97705078125 2703.726318359375 1836.1962890625 C 2703.724609375 1835.415771484375 2706.125732421875 1830.627197265625 2713.520263671875 1830.627197265625 C 2720.9150390625 1830.627197265625 2723.735595703125 1835.275390625 2723.72998046875 1835.981201171875 C 2723.72412109375 1836.686767578125 2723.72998046875 1838.4833984375 2723.72998046875 1838.4833984375 Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "d",
  transform: "translate(502.145 120.145)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "e",
  cx: 5,
  cy: 5,
  r: 5
}), /*#__PURE__*/React.createElement("circle", {
  className: "b",
  cx: 5,
  cy: 5,
  r: 4.25
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcProfile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_profile.72e631d1b8fdfd08d5abeaf9638b9271.svg";